import type { SVGProps } from "react";
export interface BasketballIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BasketballIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BasketballIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.315.903c.62.03 1.1.556 1.071 1.177-.087 1.842-.608 4.231-2.34 6.376L12 10.41l6.277-6.276a1.125 1.125 0 0 1 1.591 1.591L13.59 12l1.951 1.952c2.145-1.731 4.537-2.25 6.38-2.337a1.125 1.125 0 0 1 .105 2.247c-1.465.07-3.257.465-4.88 1.695l2.721 2.72.076.085a1.125 1.125 0 0 1-1.582 1.582l-.085-.076-2.72-2.72c-1.23 1.622-1.626 3.414-1.695 4.88a1.125 1.125 0 0 1-2.247-.106c.087-1.843.605-4.235 2.337-6.38l-1.952-1.95-6.275 6.276a1.126 1.126 0 0 1-1.59-1.59L10.409 12l-1.953-1.952c-2.145 1.73-4.534 2.252-6.377 2.34a1.125 1.125 0 1 1-.105-2.248c1.465-.069 3.256-.466 4.878-1.696l-2.719-2.72-.077-.085a1.126 1.126 0 0 1 1.583-1.583l.085.077 2.719 2.719c1.23-1.622 1.627-3.412 1.696-4.878.03-.62.556-1.1 1.176-1.07Z"
      />
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 1-17.75 0 8.875 8.875 0 0 1 17.75 0m2.25 0C23.125 5.855 18.145.875 12 .874 5.856.875.875 5.855.875 12s4.981 11.126 11.126 11.126c6.143 0 11.124-4.982 11.124-11.126"
      />
    </svg>
  );
}
